import classNames from "classnames";
import React, {useState} from "react";
import {doTrack} from "../utils/utils";

export const PreflightCheck = ({proceedToRegistration}) => {

    const [isSlackAdmin, setIsSlackAdmin] = useState(false);
    const [isZoomAdmin, setIsZoomAdmin] = useState(false);
    const [emailsMatch, setEmailsMatch] = useState(false);

    const toggleZoom = () => {
        setIsZoomAdmin(!isZoomAdmin);
        doTrack('Workspace setup - verified Zoom admin');
    };
    const toggleEmailMatch = () => {
        setEmailsMatch(!emailsMatch);
        doTrack('Workspace setup - verified emails match');
    };

    const toggleSlack = () => {
        setIsSlackAdmin(!isSlackAdmin);
        doTrack('Workspace setup - verified Slack admin');
    };

    return <div className={"flexRowContainer"}>
        <h3 className={"mb10"}>
            Pre-flight check!
        </h3>
        <div className={"mb50"}><b>Please check off and read each step.<br/>This
            is imperative to
            ensure a successful qube setup!</b>
        </div>
        <div className={"flexColumnContainer mb10"} onClick={toggleSlack}>
            <i className={classNames('far', 'mr8', 'mt4', isSlackAdmin ? 'fa-check-square' : 'fa-square mr8')}></i>I
            am a Slack administrator
        </div>
        <div className={"flexColumnContainer mb10"} onClick={toggleZoom}>
            <i className={classNames('far', 'mr8', 'mt4', isZoomAdmin ? 'fa-check-square' : 'fa-square mr8')}/>I
            am a Zoom administrator
        </div>
        <div className={"flexColumnContainer mb10"} onClick={toggleEmailMatch}>
            <i className={classNames('far', 'mr8', 'mt4', emailsMatch ? 'fa-check-square' : 'fa-square mr8')}></i>My
            emails for my Slack and Zoom accounts are the same<br/>
            (yes, they have to match!)
        </div>

        <div className={"flexRowContainer flexAlignCenter mb10"}>
            <div className={"flexColumnContainer mb8"}>
                <div className={"flexFill"}/>
                <input type="button" className="btn setupBtn" value="Submit"
                       disabled={!isSlackAdmin || !isZoomAdmin || !emailsMatch}
                       onClick={proceedToRegistration}/>
            </div>
            {(!isSlackAdmin || !isZoomAdmin || !emailsMatch) &&
            <div className={"text-muted"}>You must check all the boxes before you can proceed.</div>}
        </div>
    </div>
};